import React from "react";
import ReactDOM from "react-dom";
import Root from "./containers/Root";
import "./style/index.css";
import "ant-design-pro/dist/ant-design-pro.css"; // Import whole style

// Unregister Workbox SW from CRA builds so deploys are not stuck on cached JS (empty API base → requests hit *.azurestaticapps.net).
if (
  process.env.NODE_ENV === "production" &&
  typeof navigator !== "undefined" &&
  "serviceWorker" in navigator
) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}

ReactDOM.render(<Root />, document.getElementById("root"));